import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { selectProfilesSearchText } from "../../../store/profilesList/selector/selectProfileSearchText";

export const ProfileSearchBar = () => {
  const dispatch = useDispatch();
  const searchText = useSelector(selectProfilesSearchText);
  return (
    <>
      <IonSearchbar
        value={searchText}
        onIonChange={(e) =>
          dispatch({
            type: `profilesList/setSearchText`,
            payload: e.detail.value,
          })
        }
      />
    </>
  );
};
